import { SilentCronXError } from "./errors.js";

export function assertSerializablePayload(payload: unknown, maxBytes?: number): void {
  if (payload === undefined) return;
  try {
    const json = JSON.stringify(payload);
    if (maxBytes && Buffer.byteLength(json, "utf8") > maxBytes) {
      throw new SilentCronXError(`Payload exceeds configured maxPayloadBytes (${maxBytes})`);
    }
  } catch (error) {
    if (error instanceof SilentCronXError) throw error;
    throw new SilentCronXError("Payload must be JSON-serializable");
  }
}
